import { Media, mbSize, scaleIn, scaleOut } from '@foxrenderfarm/common/src/theme'
import styled, { css } from 'styled-components'

const baseFlex = css`
  display: flex;
  justify-content: center;
  align-items: center;
`

const basePositionZero = css`
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
`

export const Mask = styled.div<{ $delay: number }>`
  ${basePositionZero};
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: -1;
  background: #222222cc;
  transition: all ${({ $delay }) => `${$delay}ms`};
`

export const ModalStyle = styled.div<{ $zIndex: number; $visible: boolean }>`
  ${baseFlex};
  ${basePositionZero};
  position: fixed;
  width: 100vw;
  height: 100vh;
  z-index: -1;
  visibility: ${({ $visible }) => ($visible ? 'visible' : 'hidden')};
  z-index: ${({ $zIndex }) => $zIndex};
`

export const Content = styled.div<{
  top?: string
  right?: string
  left?: string
  bottom?: string
  minWidth?: string | number
  $backgroundColor?: string
  color?: string
  $visible: boolean
  $delay: number
  $isTransparent: boolean
}>`
  ${({
    top,
    right,
    left,
    bottom,
    minWidth,
    $backgroundColor,
    color,
    $visible,
    $delay,
    $isTransparent,
  }) => css`
    position: absolute;
    top: ${top ?? 'unset'};
    right: ${right ?? 'unset'};
    left: ${left ?? 'unset'};
    bottom: ${bottom ?? 'unset'};
    color: ${color ?? '#000'};
    background: ${$backgroundColor ? $backgroundColor : '#fff'};
    animation: ${$visible ? scaleIn : scaleOut} ${$delay}ms;
    min-width: ${minWidth ? (typeof minWidth === 'number' ? minWidth + 'px' : minWidth) : 'unset'};
    transition: all ${`${$delay}ms`};
    border-radius: 10px;
    margin: 20px;
    box-shadow: ${$isTransparent ? 'unset' : '0px 10px 16px 4px rgba(102, 102, 102, 0.2)'};
  `}
  ${Media.lessThan(Media.small)} {
    width: calc(100% - 40px);
  }
`

export const CloseIconWrap = styled.div<{ $isTransparent: boolean }>`
  cursor: pointer;
  ${({ $isTransparent }) =>
    $isTransparent
      ? css`
          path {
            transition: all 0.3s;
          }
          &:hover {
            path {
              stroke: #f3512b;
            }
          }
        `
      : css`
          svg {
            fill: #d9d9d9;
            transition: all 0.3s;
          }
          &:hover {
            svg {
              fill: #f3512b;
            }
          }
        `}
  ${Media.lessThan(Media.small)} {
    svg {
      width: ${mbSize(50)};
      height: ${mbSize(50)};
    }
  }
`

export const Header = styled.div`
  position: relative;
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
  padding: 20px;
  fill: #b0b3b5;
  display: flex;
  align-items: center;
  justify-content: space-between;
  ${Media.lessThan(Media.small)} {
    padding: ${mbSize(25)};
  }
`

export const Title = styled.div<{ $titleFontSize: number; $titleCenter: boolean }>`
  font-size: ${(props) => props.$titleFontSize ?? 14}px;
  margin: 0px 30px;
  ${({ $titleCenter }) =>
    $titleCenter &&
    css`
      flex: 1;
      display: flex;
      justify-content: center;
    `}
  ${Media.lessThan(Media.small)} {
    margin: 0px;
  }
`

export const Main = styled.div`
  padding: 0 20px 20px;
  max-height: 90vh;
  overflow: auto;
  ${Media.lessThan(Media.small)} {
    padding: 0 ${mbSize(25)} ${mbSize(25)};
  }
`
